import { useCallback } from 'react';
import { statsService } from '../services/statsService';
import { type LeaderboardUser, StatsLeaderboard } from './StatsLeaderboard';

export const SttSessionsLeaderboard = () => {
    const fetchUsers = useCallback(async (): Promise<LeaderboardUser[]> => {
        const users = await statsService.getTopUsersBySttSessionCount(20);
        return users.map((u) => ({
            userId: u.userId,
            email: u.email,
            displayName: u.displayName,
            value: u.sttSessionCount,
            memberSince: u.memberSince,
            lastUsedAt: u.lastUsedAt,
        }));
    }, []);

    return (
        <StatsLeaderboard
            title="STT Sessions Leaderboard"
            valueLabel="STT Sessions"
            valueUnit="sessions"
            emptyMessage="No users with STT sessions found."
            fetchUsers={fetchUsers}
            showLastUsed
        />
    );
};
